import React, { useState } from "react";

export const RequestContext = React.createContext();

export const RequestProvider = ({ children }) => {

    const [ requestType, setRequestType ] = useState("");
    const [ requestDescription, setRequestDescription ] = useState("");
    const [ headline, setHeadline ] = useState("")
    const [ requestCriteria, setRequestCriteria ] = useState([]);
    const [ imagesUpload, setImagesUpload ] = useState([]);
    const [ userLocation, setUserLocation ] = useState("")
    const [ serviceDate, setServiceDate ] = useState("")
    const [ startTime, setStartTime ] = useState("")
    const [ endTime, setEndTime ] = useState("")
    const [ serviceCost, setServiceCost ] = useState(0)
    const [ businessType, setBusinessType ] = useState("")
    const [ serviceSummary, setServiceSummary ] = useState("")
    const [ originalCost, setOriginalCost ] = useState(0)
    const [ totalDiscountPercent, setTotalDiscountPercent ] = useState(0)
    const [ serviceItems, setServiceItems ] = useState([])
    const [ serviceUnitsCount, setServiceUnitsCount ] = useState(0)
    const [ selectedPackage, setSelectedPackage ] = useState(null)

    //File Attachment
    const [ filesToAttach, setFilesToAttach ] = useState([])
    const [ filesToUpload, setFilesToUpload ] = useState([])
    
    return (
    <RequestContext.Provider
        value={{
            requestType,
            setRequestType,
            requestDescription,
            setRequestDescription,
            headline,
            setHeadline,
            requestCriteria,
            setRequestCriteria,
            userLocation,
            setUserLocation,
            serviceDate,
            setServiceDate,
            startTime,
            setStartTime,
            endTime,
            setEndTime,
            serviceCost, 
            setServiceCost,
            businessType, 
            setBusinessType,
            serviceSummary, 
            setServiceSummary,
            totalDiscountPercent,
            setTotalDiscountPercent,
            originalCost,
            setOriginalCost,
            filesToAttach, 
            setFilesToAttach,
            filesToUpload, 
            setFilesToUpload,
            serviceItems,
            setServiceItems,
            serviceUnitsCount, 
            setServiceUnitsCount,
            selectedPackage,
            setSelectedPackage
        }}
    >
        {children}        
    </RequestContext.Provider>
    )
}